/* TeamsRowGrid.tsx generated by @compiled/babel-plugin v2.0.0 */
import { ax, ix } from "@compiled/react/runtime";
require("@compiled/webpack-loader/css-loader!@compiled/webpack-loader/css-loader/compiled-css.css?style=._1LMyvKYbGa%7Blist-style%3Anone%7D");
require("@compiled/webpack-loader/css-loader!@compiled/webpack-loader/css-loader/compiled-css.css?style=._2iEGP2zmBj%7Bgrid-template-columns%3Arepeat(auto-fill%2Cminmax(22pc%2C1fr))%7D");
require("@compiled/webpack-loader/css-loader!@compiled/webpack-loader/css-loader/compiled-css.css?style=._43nrzTPgdg%7Bmargin-block-start%3Avar(--ds-space-0%2C0)%7D");
require("@compiled/webpack-loader/css-loader!@compiled/webpack-loader/css-loader/compiled-css.css?style=._0rIjykPgdg%7Bmargin-block-end%3Avar(--ds-space-0%2C0)%7D");
require("@compiled/webpack-loader/css-loader!@compiled/webpack-loader/css-loader/compiled-css.css?style=._0GTcwRPgdg%7Bmargin-inline-start%3Avar(--ds-space-0%2C0)%7D");
require("@compiled/webpack-loader/css-loader!@compiled/webpack-loader/css-loader/compiled-css.css?style=._2xTnZxPgdg%7Bmargin-inline-end%3Avar(--ds-space-0%2C0)%7D");
require("@compiled/webpack-loader/css-loader!@compiled/webpack-loader/css-loader/compiled-css.css?style=._46hvQmPgdg%7Bpadding-block-start%3Avar(--ds-space-0%2C0)%7D");
require("@compiled/webpack-loader/css-loader!@compiled/webpack-loader/css-loader/compiled-css.css?style=._0xmtkoPgdg%7Bpadding-block-end%3Avar(--ds-space-0%2C0)%7D");
require("@compiled/webpack-loader/css-loader!@compiled/webpack-loader/css-loader/compiled-css.css?style=._0LQT5EPgdg%7Bpadding-inline-start%3Avar(--ds-space-0%2C0)%7D");
require("@compiled/webpack-loader/css-loader!@compiled/webpack-loader/css-loader/compiled-css.css?style=._03SyCPPgdg%7Bpadding-inline-end%3Avar(--ds-space-0%2C0)%7D");
import React from 'react';
import { Grid } from '@atlaskit/primitives/compiled/grid';
import { Stack } from '@atlaskit/primitives/compiled/stack';
import { TeamCardSkeleton } from '@atlassian/people-teams-ui/team-card-skeleton';
import { FormattedMessage, useIntl } from 'react-intl';
import { teamsDirectoryRoute } from '@townsquare/routes/teams-directory-view';
import { fg } from '@townsquare/stat-sig/gate';
import { Heading } from '../Heading';
const BROWSE_TEAM_CARD_SLOTS = 3;
const styles = {
  gridStyles: "_1LMyvKYbGa _2iEGP2zmBj _43nrzTPgdg _0rIjykPgdg _0GTcwRPgdg _2xTnZxPgdg _46hvQmPgdg _0xmtkoPgdg _0LQT5EPgdg _03SyCPPgdg"
};
const LoadingCards = () => <>
		{[...Array(BROWSE_TEAM_CARD_SLOTS)].map((_, i) => <TeamCardSkeleton key={`BrowseTeamCardLoadingState${i}`} />)}
	</>;
function CardGrid({
  children
}: {
  children: React.ReactNode;
}) {
  return <Grid gap="space.150" xcss={styles.gridStyles} as={fg('teams-a11y-screen-reader-high-priority') ? 'ul' : undefined}>
			{children}
		</Grid>;
}
export const TeamsRowSkeleton = (): React.JSX.Element => {
  return <BrowseTeamsSectionFrame hasTeams={false}>
			<LoadingCards />
		</BrowseTeamsSectionFrame>;
};
type BrowseTeamsSectionFrameProps = {
  children: React.ReactNode;
  hasTeams: boolean;
};
export const BrowseTeamsSectionFrame = ({
  children,
  hasTeams
}: BrowseTeamsSectionFrameProps): React.JSX.Element => {
  const intl = useIntl();
  return <Stack space="space.150">
			<Heading browseMore={hasTeams ? {
      text: intl.formatMessage({
        id: 'townsquare.web.browse-teams-section.browse-all',
        description: 'Link text in the teams section heading that navigates to the full teams directory.',
        defaultMessage: 'Browse all teams'
      }),
      linkProps: {
        to: teamsDirectoryRoute,
        query: {
          screen: 'SEARCH_TEAMS'
        }
      }
    } : undefined} screenType="SEARCH_TEAMS">
				<FormattedMessage id="townsquare.web.browse-teams-section.heading" description="Browse teams section heading" defaultMessage="Your teams" />
			</Heading>
			<CardGrid>{children}</CardGrid>
		</Stack>;
};